<template>
  <div class="inventoryItems">
    <!-- 入库-产品 -->
    <el-popover
      placement="right"
      width="600"
      trigger="manual"
      v-model="product.show"
      v-if="field.frontEndConfig.type == 1"
    >
      <div>
        <el-select
          v-model="product.productBizType"
          clearable
          placeholder="请选择类型"
          class="c-m-r-10 c-select-suffix-hide"
          style="width:140px"
          @change="
            product.fpi.page = 1;
            product.version = '';
            getProducts();
          "
          @clear="
            product.fpi.page = 1;
            product.version = '';
            getProducts();
          "
        >
          <el-option
            v-for="(item, i) in options.productBizType"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-if="field.frontEndConfig.versionFilterShow"
          v-model="product.version"
          clearable
          placeholder="请选择版本号"
          class="c-m-r-10 c-select-suffix-hide"
          style="width:140px"
          @change="
            product.fpi.page = 1;
            getProducts();
          "
          @clear="
            product.fpi.page = 1;
            getProducts();
          "
        >
          <el-option
            v-for="(item, i) in options['productVersion' + product.productBizType]"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          class="search-input"
          style="width:300px"
          placeholder="请输入名称/编号搜索"
          v-model="product.searchValue"
          @clear="
            product.fpi.page = 1;
            getProducts();
          "
          @keyup.enter.native="
            product.fpi.page = 1;
            getProducts();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              product.fpi.page = 1;
              getProducts();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        height="400px"
        ref="product"
        :data="product.fpi.data"
        empty-text="暂无数据"
        @selection-change="selectProducts"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          property="name"
          label="名称"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="code"
          width="120px"
          show-overflow-tooltip
          label="型号"
        ></el-table-column>
        <el-table-column
          property="productType"
          label="类型"
          :formatter="formatProductType"
        ></el-table-column>
        <el-table-column
          property="unit"
          label="单位"
          :formatter="formatProductUnit"
        ></el-table-column>
        <!-- <el-table-column property="cost" label="成本/元"></el-table-column> -->
        <el-table-column property="price" label="单价/元"></el-table-column>
        <!-- <el-table-column property="createTime" width="140px" label="创建时间"></el-table-column> -->
      </el-table>
      <div>
        <el-pagination
          class="pagination c-m-t-10 c-m-b-10"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="product.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="product.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product.fpi.total"
        ></el-pagination>
        <div class="c-fr">
          <el-button type="primary" @click="addProducts">
            确认
          </el-button>
          <el-button @click="cancelProducts">
            取消
          </el-button>
        </div>
      </div>
      <el-button
        slot="reference"
        type="primary"
        class="c-fr"
        @click="openProducts"
        v-if="!field.frontEndConfig.inoperable || field.frontEndConfig.selectable"
      >
        选择{{ field.frontEndConfig.btnName || '' }}
      </el-button>
    </el-popover>
    <!-- 出库-库存 -->
    <el-popover
      placement="right"
      width="600"
      trigger="manual"
      v-model="inventory.show"
      v-if="field.frontEndConfig.type == 2"
    >
      <div>
        <el-select
          v-model="inventory.productBizType"
          clearable
          placeholder="请选择类型"
          class="c-m-r-10 c-select-suffix-hide"
          style="width:140px"
          @change="
            inventory.fpi.page = 1;
            getInventory();
          "
          @clear="
            inventory.fpi.page = 1;
            getInventory();
          "
        >
          <el-option
            v-for="(item, i) in options.productBizType"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          class="search-input"
          style="width:300px"
          placeholder="请输入库存名称/编号搜索"
          v-model="inventory.searchValue"
          clearable
          @clear="
            inventory.fpi.page = 1;
            getInventory();
          "
          @keyup.enter.native="
            inventory.fpi.page = 1;
            getInventory();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              inventory.fpi.page = 1;
              getInventory();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        height="400px"
        ref="inventory"
        :data="inventory.fpi.data"
        empty-text="没有查询到"
        @selection-change="selectInventory"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          property="name"
          label="名称"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="code"
          width="120px"
          show-overflow-tooltip
          label="编号"
        ></el-table-column>
        <el-table-column
          property="unit"
          label="单位"
          :formatter="formatProductUnit"
        ></el-table-column>
        <el-table-column
          property="productType"
          label="类型"
          :formatter="formatProductType"
        ></el-table-column>
        <el-table-column property="count" label="库存数量"></el-table-column>
        <el-table-column property="warehouseName" label="所属仓库"></el-table-column>
      </el-table>
      <div>
        <el-pagination
          class="pagination c-m-t-10 c-m-b-10"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="inventory.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="inventory.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="inventory.fpi.total"
        ></el-pagination>
        <div class="c-fr">
          <el-button type="primary" @click="addInventory">
            确认
          </el-button>
          <el-button @click="cancelInventory">
            取消
          </el-button>
        </div>
      </div>
      <el-button
        slot="reference"
        type="primary"
        class="c-fr"
        @click="openInventory"
        v-if="!field.frontEndConfig.inoperable || field.frontEndConfig.selectable"
      >
        选择{{ field.frontEndConfig.btnName || '' }}
      </el-button>
    </el-popover>
    <el-table ref="productList" :data="formData[fieldName]">
      <el-table-column
        label="名称"
        width="120px"
        prop="name"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="型号"
        width="80px"
        prop="code"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="单位"
        width="50px"
        prop="unit"
        :formatter="formatProductUnit"
      ></el-table-column>
      <el-table-column label="数量" width="140px" v-if="field.frontEndConfig.type == 1">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.count"
            :controls="false"
            :precision="0"
            :min="1"
            :disabled="scope.row.pIICodes.length > 0 ? true : false"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        label="库存数量"
        width="80px"
        prop="inventoryCount"
        v-if="field.frontEndConfig.type == 2"
      ></el-table-column>
      <el-table-column label="数量" width="140px" v-if="field.frontEndConfig.type == 2">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.count"
            :controls="false"
            :precision="0"
            :min="1"
            :max="scope.row.inventoryCount"
            :disabled="scope.row.pIICodes.length > 0 ? true : false"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="序列号" width="250px" v-if="!field.frontEndConfig.pIICodesHide">
        <template slot-scope="scope">
          <el-select
            style="width:100%"
            :class="field.frontEndConfig.type == 1 && !scope.row.verify ? 'sel-danger' : ''"
            v-model="scope.row.pIICodes"
            @change="codesChange(scope.row)"
            multiple
            filterable
            clearable
            :allow-create="field.frontEndConfig.type == 1 ? true : false"
            default-first-option
            :multiple-limit="scope.row.inventoryCount || 0"
            :placeholder="
              field.frontEndConfig.type == 1
                ? '请输入序列号后选择，可多选'
                : '请选择要出库设备的序列号'
            "
            :no-data-text="field.frontEndConfig.type == 1 ? '请输入序列号后选择，可多选' : ''"
            :no-match-text="field.frontEndConfig.type == 1 ? '请输入序列号后选择，可多选' : ''"
          >
            <el-option
              v-for="pIICode in scope.row.pIIOptions || []"
              :key="pIICode"
              :label="pIICode"
              :value="pIICode"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.memo"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="80"
        label="操作"
        v-if="!field.frontEndConfig.inoperable || field.frontEndConfig.clearable"
      >
        <template slot-scope="scope">
          <el-button @click.native.prevent="productDelete(scope.$index)" size="mini">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'inventoryItems',
  props: {
    formData: Object,
    field: Object
  },
  data() {
    return {
      fieldName: this.field.name,

      type: '', //出入库明细类型
      typeName: '',
      name: 'inventoryItem',
      refresh: true,
      fpi: {},
      searchValue: '',
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      product: {
        show: false,
        searchValue: '',
        productBizType: '',
        version: '',
        fpi: { data: [] },
        selectedRows: []
      },
      inventory: {
        show: false,
        searchValue: '',
        productBizType: '',
        version: '',
        fpi: { data: [] },
        selectedRows: []
      },
      options: {
        codecfg_productUnit: {
          codeId: 'partUnit'
        },
        codecfg_productType: {
          codeId: 'productType'
        },
        codecfg_productBizType: {
          codeId: 'productBizType'
        },
        // 产品版本号
        codecfg_productVersion1: {
          codeId: 'productVersion1'
        },
        codecfg_productVersion2: {
          codeId: 'productVersion2'
        },
        codecfg_productVersion3: {
          codeId: 'productVersion3'
        },
        codecfg_productVersion4: {
          codeId: 'productVersion4'
        },
        codecfg_productVersion5: {
          codeId: 'productVersion5'
        }
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.codeoption(() => {
      // 更新视图返显单位
      let items = this.formData[this.fieldName] || [];
      for (let item of items) {
        item.memo = item.memo + ' ';
        item.memo = item.memo.substring(0, item.memo.length - 1);
      }
    }, this);
  },
  methods: {
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue, this);
    },
    formatProductUnit(row, column, cellValue) {
      return this.osg.codelabel('productUnit', cellValue, this);
    },
    pageSizeChange(pageSize) {
      if (this.product.show) {
        this.product.fpi.rows = pageSize;
        this.getProducts();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.product.show) {
        this.product.fpi.page = currentPage;
        this.getProducts();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.formData[this.fieldName] = this.formData[this.fieldName] || [];
      this.product.show = false;
      this.$forceUpdate();
    },
    //点击添加产品按钮
    openProducts() {
      this.product = {
        show: true,
        searchValue: '',
        productBizType: '',
        version: '',
        fpi: { data: [] },
        selectedRows: []
      };
      this.getProducts();
    },
    // 查询未添加的产品
    getProducts() {
      // 收集已添加产品的_id
      let productList = this.formData[this.fieldName] || [];
      let arr = [];
      for (let product of productList) {
        arr.push(product.id);
      }

      let params = {
        page: this.product.fpi.page,
        rows: this.product.fpi.rows,
        'is:state|integer#and': 1,
        'is:productState|integer#and': 3, //审核通过
        'regex:name|string#or': this.product.searchValue,
        'regex:code|string#or': this.product.searchValue,
        'nin:_id|array#and': arr,
        'in:productType|array#and': '2,3', //实物产品,备件
        'is:productBizType|string#and': this.product.productBizType,
        'is:exts.version|string#and': this.product.version,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      if (this.field.frontEndConfig.notFilterOrgId) params['notFilterOrgId'] = '1';
      if (this.field.frontEndConfig.notFilterBelongTo) params['notFilterBelongTo'] = '1';
      if (this.field.frontEndConfig.params)
        params = Object.assign(params, this.field.frontEndConfig.params);

      this.osg.ajax('basic/product/query.do', params, res => {
        this.product.fpi = res;
        this.$nextTick(() => {
          this.$refs.product.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择产品
    selectProducts(rows) {
      if (rows) {
        this.product.selectedRows = rows;
      } else {
        this.$refs.product.clearSelection();
        this.product.selectedRows = [];
      }
    },
    // 确认添加选中的产品
    addProducts() {
      let productList = [];
      this.product.selectedRows.map(item => {
        productList.push({
          id: item._id,
          name: item.name,
          code: item.code,
          unit: item.unit,
          count: 0,
          handleCount: 0,
          memo: '',
          pIICodes: [],
          verify: true //是否允许入库的校验
        });
      });
      this.formData[this.fieldName] = this.formData[this.fieldName] || [];
      this.formData[this.fieldName] = this.formData[this.fieldName].concat(productList);
      this.cancelProducts();
    },
    // 关闭添加产品弹窗 并取消已选中产品
    cancelProducts() {
      this.product.show = false;
      this.selectProducts();
    },
    // 移除已添加的单个产品
    productDelete(i) {
      this.formData[this.fieldName].splice(i, 1);
    },
    //点击添加产品按钮
    openInventory() {
      if (this.field.frontEndConfig.warehouseRequired && !this.formData.warehouseId) {
        this.osg.toast('请先选择出库仓库', 'warning');
        return;
      }
      this.inventory = {
        show: true,
        searchValue: '',
        productBizType: '',
        version: '',
        fpi: { data: [] },
        selectedRows: []
      };
      this.getInventory();
    },
    getInventory() {
      // 收集已添加产品的_id
      let productList = this.formData[this.fieldName] || [];
      let arr = [];
      for (let product of productList) {
        arr.push(product.id);
      }

      let params = {
        page: this.inventory.fpi.page,
        rows: this.inventory.fpi.rows,
        'is:state|integer#and': 1,
        'regex:name|string#or': this.inventory.searchValue,
        'regex:code|string#or': this.inventory.searchValue,
        'is:productBizType|string#and': this.inventory.productBizType,
        'is:warehouseId|string#and': this.formData.warehouseId,
        'nin:bizId|array#and': arr,
        'gt:count|integer#and': 0,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      if (this.field.frontEndConfig.notFilterOrgId) params['notFilterOrgId'] = '1';
      if (this.field.frontEndConfig.notFilterBelongTo) params['notFilterBelongTo'] = '1';
      if (this.field.frontEndConfig.params)
        params = Object.assign(params, this.field.frontEndConfig.params);

      this.osg.ajax('basic/inventory/query.do', params, res => {
        this.inventory.fpi = res;
        this.$nextTick(() => {
          this.$refs.inventory.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择产品库存
    selectInventory(rows) {
      if (rows) {
        this.inventory.selectedRows = rows;
      } else {
        this.$refs.inventory.clearSelection();
        this.inventory.selectedRows = [];
      }
    },
    // 确认添加选中的产品库存
    addInventory() {
      let productList = [];
      this.inventory.selectedRows.map(item => {
        productList.push({
          id: item.bizId,
          name: item.name,
          code: item.code,
          unit: item.unit,
          inventoryCount: item.count,
          count: 0,
          handleCount: 0,
          memo: '',
          pIIOptions: item.productInventoryItemCodes || [],
          pIICodes: []
        });
      });
      this.formData[this.fieldName] = this.formData[this.fieldName] || [];
      this.formData[this.fieldName] = this.formData[this.fieldName].concat(productList);
      this.cancelInventory();
    },
    // 关闭添加产品库存弹窗 并取消已选中产品库存
    cancelInventory() {
      this.inventory.show = false;
      this.selectInventory();
    },
    codesChange(row) {
      if (!this.field.frontEndConfig.check) return;
      row.count = row.pIICodes.length;
      if (this.field.frontEndConfig.type == 1) {
        if (row.pIICodes.length > 0) {
          // 校验是否已入库
          this.osg.ajax(
            '/basic/productInventoryItem/checkInventoryExistsByCode.do',
            {
              codes: row.pIICodes.join(),
              productId: row.id
            },
            res => {
              if (res.data && res.data.length > 0) {
                this.osg.alert('序列号' + String(res.data) + '已入库，请勿重复入库！', 'warning');
                row.verify = false;
              } else {
                row.verify = true;
              }
            },
            { noload: true }
          );
        } else {
          row.verify = true;
        }
      }
    }
  }
};
</script>
<style>
.flows .el-dialog {
  width: 1200px !important;
}
.inventoryItems .c-dialog-height {
  height: 80vh !important;
}
.sel-danger .el-input__inner {
  border: 1px solid #f56c6c !important;
}
.c-select-suffix-hide .el-icon-circle-check {
  display: none;
}
</style>
